import { render, staticRenderFns } from "./addShareProportion.vue?vue&type=template&id=02c3ece1&"
import script from "./addShareProportion.vue?vue&type=script&lang=js&"
export * from "./addShareProportion.vue?vue&type=script&lang=js&"
import style0 from "./addShareProportion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02c3ece1')) {
      api.createRecord('02c3ece1', component.options)
    } else {
      api.reload('02c3ece1', component.options)
    }
    module.hot.accept("./addShareProportion.vue?vue&type=template&id=02c3ece1&", function () {
      api.rerender('02c3ece1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/components/addShareProportion.vue"
export default component.exports